import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import { MxAccount } from '../../models/mx';
import {
  DatePickerField,
  FullWidthTextField,
  SelectField,
} from '../shared/Forms/FullWidthForm/fullWidthFormComponents';
import { decimal, nonNegative, required } from '../shared/Forms/validations';

export type AddTransactionFormValues = {
  account: string;
  amount: number;
  date: Date;
  description: string;
  topLevelCategory: string;
  type: string;
};
type AddTransactionFormProps = {
  accounts: MxAccount[];
  onClose: () => void;
};

// prettier-ignore
const categories = [
  'Auto & Transport', 'Bills & Utilities', 'Business Services', 'Education', 'Entertainment', 'Fees & Charges', 'Financial', 'Food & Dining', 'Gifts & Donations', 'Health & Fitness', 'Home', 'Income', 'Investments', 'Kids', 'Personal Care', 'Pets', 'Shopping', 'Taxes', 'Transfer', 'Travel', 'Uncategorized'];
const categoryMap = categories.map((category) => ({ name: category, value: category }));
const typeMap = [
  { name: 'Income', value: 'CREDIT' },
  { name: 'Expense', value: 'DEBIT' },
];

const AddTransactionForm: React.FunctionComponent<
  AddTransactionFormProps & InjectedFormProps<AddTransactionFormValues, AddTransactionFormProps>
> = ({ accounts, handleSubmit, onClose, submitting }) => {
  const accountMap = useMemo(() => {
    const newAccounts = accounts.map((account) => ({ name: account.name, value: account.guid }));
    newAccounts.unshift({ name: 'No Account', value: 'no-account' });
    return newAccounts;
  }, [accounts]);

  return (
    <form onSubmit={handleSubmit}>
      <DialogTitle>Add a Transaction</DialogTitle>
      <DialogContent>
        <Field
          component={FullWidthTextField}
          label="Description"
          name="description"
          type="text"
          validate={required}
        />
        <Field
          component={FullWidthTextField}
          fieldFormat="dollar"
          label="Amount"
          name="amount"
          parse={(value) => (value ? Number(value) : value)}
          type="number"
          validate={[decimal, nonNegative, required]}
        />
        <Field
          component={DatePickerField}
          label="Date"
          name="date"
          type="date"
          validate={required}
        />
        <Field
          component={SelectField}
          dataMap={accountMap}
          label="Account"
          name="account"
          validate={required}
        />
        <Field
          component={SelectField}
          dataMap={categoryMap}
          label="Category"
          name="topLevelCategory"
          validate={required}
        />
        <Field
          component={SelectField}
          dataMap={typeMap}
          label="Type"
          name="type"
          validate={required}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} variant="contained">
          Cancel
        </Button>
        <Button color="primary" disabled={submitting} type="submit" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </form>
  );
};

export default reduxForm<AddTransactionFormValues, AddTransactionFormProps>({
  form: 'addTransactionForm',
  enableReinitialize: true,
})(AddTransactionForm);
